var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { value: _vm.dialog, "max-width": "500px" },
      on: {
        "click:outside": function ($event) {
          return _vm.$emit("updateDialog", false)
        },
      },
    },
    [
      _vm.node
        ? _c(
            "v-card",
            [
              _c(
                "v-form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.assign.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("v-card-title", [
                    _c("span", { staticClass: "headline" }, [
                      _vm._v("Responsable de " + _vm._s(_vm.node.name)),
                    ]),
                  ]),
                  _c(
                    "v-card-text",
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: "Legajo responsable",
                          items: _vm.legajos,
                          "item-text": _vm.legajoText,
                          "item-value": "id",
                          "return-object": "",
                          clearable: "",
                          loading: _vm.loading_legajos,
                          hint: "Deje vacío para marcar el puesto como vacante",
                          "persistent-hint": "",
                        },
                        model: {
                          value: _vm.legajo,
                          callback: function ($$v) {
                            _vm.legajo = $$v
                          },
                          expression: "legajo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "error", text: "" },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("updateDialog", false)
                            },
                          },
                        },
                        [_vm._v("Cerrar")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "success",
                            text: "",
                            type: "submit",
                            loading: _vm.loading,
                          },
                        },
                        [_vm._v("Guardar")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }